import React from "react";
import { Modal } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";

const CustomModal = ({
  title,
  open,
  onCancel,
  className,
  style,
  content,
  cancelButtonProps,
  cancelText,
  centered,
  onOk,
  width,
  maskClosable,
  closable = true,
  loading
}) => {
  return (
    <Modal
      title={title}
      open={open}
      closeIcon={<CloseCircleOutlined style={{ fontSize: 26 }} />}
      closable={closable}
      footer={null}
      onCancel={onCancel}
      className={className}
      style={style}
      cancelButtonProps={cancelButtonProps}
      cancelText={cancelText}
      centered={centered}
      onOk={onOk}
      width={width}
      maskClosable={maskClosable}
      loading={loading}
    >
      {content}
    </Modal>
  );
};

export default CustomModal;
